import type { ApiResponse } from '@klaro7/shared-types';
import type { FiscalProfile, FiscalDocumentType } from '@klaro7/shared-types';

import api from '@/lib/api';

/** Soglie e calcoli della prestazione occasionale — solo per regime OCCASIONALE. */
export interface FiscalRitenutaInfo {
  sogliaMax: number;
  lordoYtd: number;
  residuo: number;
  percentuale: number;
  aliquota: number;
  bolloSoglia: number;
  bolloImporto: number;
  soglieNotifica: { n3000: boolean; n4000: boolean; n4500: boolean };
}

export interface AdminFiscalProfileResponse {
  profile: FiscalProfile;
  ritenuta: FiscalRitenutaInfo | null;
}

/** Profilo fiscale di un professionista — solo super-admin. 404 se mai compilato. */
export async function getAdminFiscalProfile(
  professionalId: string
): Promise<AdminFiscalProfileResponse> {
  const { data } = await api.get<ApiResponse<AdminFiscalProfileResponse>>(
    `/fiscal/admin/professionals/${professionalId}/profile`
  );
  return data.data;
}

/** Scarica un documento fiscale caricato dal professionista (blob, richiede auth header). */
export async function downloadAdminFiscalDocument(
  professionalId: string,
  docType: FiscalDocumentType
): Promise<Blob> {
  const { data } = await api.get(
    `/fiscal/admin/professionals/${professionalId}/documents/${docType}`,
    { responseType: 'blob' }
  );
  return data as Blob;
}
